import React, { Fragment, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  Button,
  Label,
  ButtonDropdown,
  Form,
  FormGroup,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardTitle,
  CardText,
} from "reactstrap";
import withReducer from "../../../store/withReducer";
import partnerReducer from "../store";
import Breadcrumbs from "../../../layout/breadcrumb";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import { useDispatch, useSelector } from "react-redux";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { mapSearchAutoSuggestion } from "../../../utils/mapper";
import { getUsersApi } from "../../../services/manage-user/user";
import BackInStockTable from "../../backInStock/content/backInStockTable";
import { exportMismatchnDetails, getMismatcheddData, getStatementReconsiliationSettings, setReconciliationVal } from "../store/partnerSlice";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import PreLoader from "../../../share-components/ui/preLoader";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

const customMultiStyles = {
  ...customStyles,

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#656E78",
    color: "#fff",
    // borderRadius: "4px",
    padding: "2px 4px",
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#fff",
    fontWeight: 500,
  }),

  multiValueRemove: (base) => ({
    ...base,
    color: "#fff",
    ":hover": {
      backgroundColor: "#333",
      color: "#fff",
    },
  }),
};

const styles = { minHeight: "50px !important", border: "none !important", display: "block", paddingLeft: 0 };

function MismatchOrders() {
  const dispatch = useDispatch();
  const partnerState = useSelector(({ partner }) => partner.partner);
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
  const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);
  const [appDecDateRange, setAppDecDateRange] = useState([null, null]);
  const [actionDropdownOpen, setActionDropdownOpen] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [searchOrderId, setSearchOrderId] = useState(null);
  const [sku, setSku] = useState(null);
  const [timer, setTimer] = useState(null);
  const [processedBy, setProcessedBy] = useState(null);
  const [approvedBy, setApprovedBy] = useState(null);
  const [status, setStatus] = useState();
  const [partner, setPartner] = useState(null);
  const [appReason, setAppReason] = useState(null);
  const [decReason, setDecReason] = useState(null);
  const [orderCheckBoxData, setOrderCheckBoxData] = useState({ idArray: [], dataObj: [] });
  const [isChecked, setIsChecked] = useState(null);
  const [itemIdArray, setItemIdArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, endDate] = dateRange;
  const [appDecStartDate, appDecEndDate] = appDecDateRange;

  const dataMenu = [
    {
      type: 1,
      text: "Mismatched Orders",
    },
  ];

  const statusOptions = [
    { value: 2, label: "Approved" },
    { value: 3, label: "Declined" },
  ];

  useEffect(() => {
    dispatch(getStatementReconsiliationSettings()).then((res) => {
      dispatch(setReconciliationVal(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    if (startDate && endDate) {
      getData();
    }
  }, [
    dispatch,
    page,
    pageSize,
    startDate,
    endDate,
    appDecStartDate,
    appDecEndDate,
    searchOrderId,
    sku,
    appReason,
    decReason,
    processedBy,
    approvedBy,
    partner,
    status,
  ]);

  const getData = () => {
    const data = {
      page,
      pageSize,
      start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
      end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
      ...(appDecStartDate && {
        app_dec_start_date: moment(appDecStartDate).format("YYYY-MM-DD"),
      }),
      ...(appDecEndDate && {
        app_dec_end_date: moment(appDecEndDate).format("YYYY-MM-DD"),
      }),
      ...(searchOrderId && {
        order_id: searchOrderId,
      }),
      ...(sku && {
        sku: sku,
      }),
      ...(appReason && {
        approve_reason: appReason.id,
      }),
      ...(decReason && {
        decline_reason: decReason.id,
      }),
      ...(processedBy && {
        processed_by: processedBy.value,
      }),
      ...(approvedBy && {
        approved_by: approvedBy.value,
      }),
      ...(partner && {
        partner: partner.id,
      }),
      ...(status && {
        status: status.value,
      }),
    };

    setLoading(true);
    dispatch(getMismatcheddData(data)).then((res) => {
      setLoading(false);
    });
  };

  const tableColumns = [
    {
      name: "Order #",
      selector: (row) => row.order_name,
      sortable: true,
      center: false,
    },
    {
      name: "SKU",
      selector: (row) => row.sku,
      sortable: true,
      left: true,
      width: "200px",
    },
    {
      name: "Goddiva Price",
      selector: (row) => row.price,
      sortable: true,
      center: false,
    },
    {
      name: "Marketplace Price",
      selector: (row) => row.excel_price,
      sortable: true,
      center: false,
    },
    {
      name: "Reason",
      selector: (row) => row.reason,
      sortable: true,
      center: false,
      width: "200px",
    },
    {
      name: "Partner",
      selector: (row) => row.partner,
      sortable: true,
      center: false,
    },
    {
      name: "Mismatch Status",
      selector: (row) => (
        <div className="py-1">
          {row.statuses.length > 0 ? (
            row.statuses.map((s, i) => (
              <p
                key={i}
                style={{
                  color: "#dc0000",
                  fontWeight: 500,
                  marginBottom: 1,
                  marginTop: 1,
                }}
              >
                {s}
              </p>
            ))
          ) : (
            <p
              style={{
                color: "#139a35",
                fontWeight: 500,
                marginBottom: 1,
                marginTop: 1,
              }}
            >
              No Mismatch
            </p>
          )}
        </div>
      ),
      sortable: true,
      center: false,
      width: "200px",
      sortable: true,
      center: false,
    },
    {
      name: "Processed By",
      selector: (row) => row.processed_by ?? "-",
      sortable: true,
      center: false,
    },
    {
      name: "Approved/Declined By",
      selector: (row) => row.approve_by,
      sortable: true,
      center: false,
      width: "200px",
    },
    {
      name: "Order Date",
      selector: (row) => row.order_date,
      sortable: true,
      center: false,
      width: "200px",
    },
    {
      name: "Approved/Declined Date",
      selector: (row) => row.app_dec_date,
      sortable: true,
      center: false,
      width: "200px",
    },
    {
      name: "Status",
      selector: (row) => row.approved_decline,
      sortable: true,
      center: false,
    },
    {
      name: "Action",
      selector: (row) => {
        return (
          <Link to={`${process.env.PUBLIC_URL}/order/${row.order_id}/view`}>
            <span className="text-primary" style={{ fontSize: "1.5rem" }}>
              <i class="fa fa-eye" aria-hidden="true"></i>
            </span>
          </Link>
        );
      },
      sortable: true,
      center: false,
    },
  ];

  const actionToggle = () => setActionDropdownOpen((prevState) => !prevState);

  const userPromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(mapSearchAutoSuggestion(getUsersApi(data)));
      });
    });

  const handleChange = (state) => {
    const selectedIDs = state.selectedRows.map((row) => row.id);
    const dataobj = state.selectedRows.map((row) => {
      return {
        id: row.id,
        isSales: row.is_sales,
      };
    });

    setOrderCheckBoxData({ idArray: selectedIDs, dataObj: dataobj });
    setItemIdArray(selectedIDs);
    setIsChecked(selectedIDs.length > 0);
  };

  const pageChange = (e) => {
    setPage(e);
  };

  const onPageSizeChange = (e) => {
    setPage(1);
    setPageSize(e);
  };

  const handleExport = () => {
    const salesReturnData = orderCheckBoxData.dataObj;

    const data = {
      salesReturnData
    };

    setExportLoading(true);
    const outputFilename = `Mismatch_Exports${new Date().toJSON().slice(0, 10)}.csv`;
    dispatch(exportMismatchnDetails({ ...data })).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      setExportLoading(false);
    });
  };

  console.log("orderCheckBoxData", orderCheckBoxData);
  return (
    <Fragment>
      <Breadcrumbs title="Mismatched Orders" data={dataMenu} />
      <div className="product-grid">
        <div className="feature-products">
          <Card>
            <CardBody style={{ padding: 10 }}>
              <Row className="align-items-center">
                <Col>
                  <div className="dashboard-datepicker p-2">
                    <p style={{ marginBottom: 0, marginLeft: 17, fontSize: 16, fontWeight: 500, color: "#b0abab" }}>Order Date</p>
                    <DateRangePicker
                      size="lg"
                      style={styles}
                      appearance="subtle"
                      placeholder="Select Date Range"
                      className="form-control hide-border-control"
                      character=" - "
                      format="dd/MM/yyyy"
                      value={dateRange}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      cleanable={false}
                      disabled={loading}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="dashboard-datepicker p-2">
                    <p style={{ marginBottom: 0, marginLeft: 17, fontSize: 16, fontWeight: 500, color: "#b0abab" }}>Approved/Declined Date</p>

                    <DateRangePicker
                      size="lg"
                      style={styles}
                      appearance="subtle"
                      placeholder="Select Date Range"
                      className="form-control hide-border-control"
                      character=" - "
                      format="dd/MM/yyyy"
                      value={appDecDateRange}
                      onChange={(update) => {
                        setAppDecDateRange(update);
                      }}
                      cleanable={false}
                      disabled={loading}
                    />
                  </div>
                </Col>

                <Col className="align-items-end justify-content-end">
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <FormGroup className="m-0">
                      <Input
                        type="text"
                        className="form-control mb-0"
                        defaultValue={searchOrderId}
                        onChange={(e) => {
                          clearTimeout(timer);
                          const newTimer = setTimeout(() => {
                            setSearchOrderId(e.target.value);
                          }, 500);
                          setTimer(newTimer);
                        }}
                        placeholder="Search Order Id"
                      />
                      <i className="fa fa-search"></i>
                    </FormGroup>
                  </Form>
                </Col>
                <Col>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <FormGroup className="m-0">
                      <Input
                        type="text"
                        className="form-control mb-0"
                        defaultValue={sku}
                        onChange={(e) => {
                          clearTimeout(timer);
                          const newTimer = setTimeout(() => {
                            setSku(e.target.value);
                          }, 500);
                          setTimer(newTimer);
                        }}
                        placeholder="Search SKU"
                      />
                      <i className="fa fa-search"></i>
                    </FormGroup>
                  </Form>
                </Col>

                <Col className="d-flex align-items-center justify-content-end">
                  <ButtonDropdown isOpen={actionDropdownOpen} toggle={actionToggle}>
                    <DropdownToggle caret color="success" className="btn btn-success btn-square" disabled={btnDisable}>
                      {btnDisable ? (
                        <span>
                          {" "}
                          <i className="fa fa-spinner fa-spin fa-lg spinner mr-1" /> Action
                        </span>
                      ) : (
                        "Action"
                      )}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Action 01</DropdownItem>
                      <DropdownItem>Action 02</DropdownItem>
                      <DropdownItem>Action 03</DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>

                  <Button type="button" color="primary" className="ml-3" disabled={exportLoading} onClick={handleExport}>
                    <i className={exportLoading ? "fa fa-spinner fa-spin mr-1" : "fa fa-download mr-1"}></i>
                    Export
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row>
            <Col>
              <Select
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                placeholder="Approved Reason"
                className="select2-filter"
                isClearable
                options={partnerState.reconciliationSettings.approveReasons || []}
                styles={customMultiStyles}
                onChange={(selected) => {
                  setAppReason(selected);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isDisabled={loading}
              />
            </Col>
            <Col>
              <Select
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                placeholder="Declined Reason"
                className="select2-filter"
                isClearable
                options={partnerState.reconciliationSettings.declineReasons || []}
                styles={customMultiStyles}
                onChange={(selected) => {
                  setDecReason(selected);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isDisabled={loading}
              />
            </Col>
            <Col>
              <AsyncSelect
                className="select2-filter"
                isClearable={true}
                cacheOptions
                defaultOptions
                placeholder="Processed By"
                loadOptions={userPromiseOption}
                styles={{
                  ...customStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 100 }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                onClear={(e) => {}}
                onChange={(e) => {
                  setProcessedBy(e ? e : null);
                }}
                isDisabled={loading}
              />
            </Col>
            <Col>
              <AsyncSelect
                className="select2-filter"
                isClearable={true}
                cacheOptions
                defaultOptions
                placeholder="Approved By"
                loadOptions={userPromiseOption}
                styles={{
                  ...customStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 100 }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                onClear={(e) => {}}
                onChange={(e) => {
                  setApprovedBy(e ? e : null);
                }}
                isDisabled={loading}
              />
            </Col>
            <Col>
              <Select
                placeholder={<div>Select the Partner</div>}
                className="select2-filter"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                isClearable
                cacheOptions
                styles={customStyles}
                options={partnerState.reconciliationSettings.partners || []}
                onChange={(selected) => {
                  setPartner(selected);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isDisabled={loading}
              />
            </Col>
            <Col>
              <Select
                placeholder="Select Status"
                className="select2-filter"
                isClearable
                options={statusOptions}
                styles={customMultiStyles}
                onChange={(selected) => {
                  setStatus(selected);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isDisabled={loading}
              />
            </Col>
          </Row>

          <Card className="mt-4 ribbon-wrapper">
            <CardBody>
              {loading ? (
                <div style={{ minHeight: 400 }}>
                  <PreLoader />
                </div>
              ) : (
                <div className="table-responsive product-table">
                  <BackInStockTable
                    // toggleRowSelected={toggleRowSelected}
                    paginationTotalRows={partnerState.misMatchedTableRow}
                    idArray={orderCheckBoxData}
                    tableColumns={tableColumns}
                    backStockData={partnerState.misMatchedData || []}
                    backInRequestState={partnerState}
                    pageChange={pageChange}
                    handleChange={handleChange}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    onPageSizeChange={onPageSizeChange}
                    paginationDefaultPage={page}
                    paginationPerPage={pageSize}
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </Fragment>
  );
}

export default withReducer([{ partner: partnerReducer }])(MismatchOrders);
